import { logger } from '../tools/logger';
import { i18n } from '@/tools/i18n';

function createChapterLabel(post, open) {
	return `${i18n.t('chapter')} ${post.textContent} ${open ? i18n.t('opened') : i18n.t('closed')}`;
}
export default {
	init() {
		const chapterConfig = this.$store.state.dataSourceCFG
			? this.$store.state.dataSourceCFG.configWebClient.zipStyle
			: null;
		let first = true;
		let wrapper;
		let counter = 0;
		for (const post of [...this.$el.querySelectorAll('.post')]) {
			if (post.classList.contains('post--chapterStart')) {
				logger.log('Chapter Start');
				// Create new Wrapper
				wrapper = document.createElement('div');
				wrapper.setAttribute('zip-group', counter);
				wrapper.setAttribute('hidden', '');
				if (chapterConfig.openAll || (chapterConfig.openFirst && first)) {
					wrapper.removeAttribute('hidden');
					post.setAttribute('open', '');
				}

				const num = counter;
				counter++;

				post.after(wrapper);
				// screen reader labels
				post.setAttribute('role', 'switch');
				post.setAttribute('aria-label', createChapterLabel(post, false));
				post.setAttribute('aria-checked', 'false');
				post.addEventListener('click', () => {
					const chapterContainer = this.$el.querySelector(`div[zip-group='${num}']`);
					logger.log('Chapter click it is open', post.hasAttribute('open'));
					if (post.hasAttribute('open')) {
						if (!chapterConfig.closeable) return; // Do nothing chapter are not close able
						post.removeAttribute('open');
						post.setAttribute('aria-label', createChapterLabel(post, false));
						post.setAttribute('aria-checked', 'false');
						chapterContainer.setAttribute('hidden', '');
						chapterContainer.removeAttribute('open');
					} else {
						if (chapterConfig.openSingle) {
							[...this.$el.querySelectorAll('div[zip-group]')].forEach(element =>
								element.setAttribute('hidden', '')
							);
							[...this.$el.querySelectorAll('.post--chapterStart')].forEach(element =>
								element.removeAttribute('open')
							);
						}
						post.setAttribute('open', '');
						post.setAttribute('aria-label', createChapterLabel(post, true));
						post.setAttribute('aria-checked', 'true');
						chapterContainer.removeAttribute('hidden');
						chapterContainer.setAttribute('open', '');
					}
				});
				first = false;
			} else if (post.classList.contains('post--chapterEnd')) {
				logger.log('Chapter End');
				wrapper = null;
			} else if (wrapper) {
				wrapper.appendChild(post);
				logger.log('Chapter normal');
			}
		}
	},
};
